export default __webpack_public_path__ + "static/media/paola.53f5ff47.jpeg";